import React from 'react';

import { t } from '../../../../services/i18nService';
import storeManager from '../../../../store/StoreManager';
import styles from '../../testOverview.scss';
import RemoteOralExamConstants from '../../../../constants/RemoteOralExamConstants';
import remoteOralExamActions from '../../../../actions/RemoteOralExamActions';
import sessionReader from '../../../../store/readHelpers/SessionReader';

const TestCallDescription = () => {
    const handleCallIssues = () => {
        const store = storeManager.getStore();
        store.dispatch(
            remoteOralExamActions.setTestZoomCallStatus(RemoteOralExamConstants.zoomTestCallStatus.FAILED),
        );
    };

    const handleCallConfirmed = () => {
        const store = storeManager.getStore();
        store.dispatch(
            remoteOralExamActions.setTestZoomCallStatus(RemoteOralExamConstants.zoomTestCallStatus.CONFIRMED),
        );
    };

    return (<div className={styles.zoomCallDescription}>
        {sessionReader.isZoomHuichangEnabled() ?
            <div className={styles.zoomCallDescriptionItem}>
                {t('remoteOralExam.testCall.description')}
            </div>
            :
            <div
                className={styles.zoomCallDescriptionItem}
                dangerouslySetInnerHTML={{ __html: t('remoteOralExam.testCall.zoomManualJoinDescription') }}
            />
        }

        <div className={styles.zoomCallDescriptionItem}>
            {t('remoteOralExam.testCall.confirmation')}
        </div>

        <div className={styles.zoomCallDescriptionItem}>
            <button
                className={`${styles.button} btn`}
                onClick={handleCallConfirmed}
            >
                <i className="fa fa-arrow-right" aria-hidden />
                {t('general.continue')}
            </button>
        </div>

        <div className={styles.zoomCallDescriptionItem}>
            <button
                className={styles.linkTypeButton}
                onClick={handleCallIssues}
            >
                {t('remoteOralExam.testCall.havingIssues')}
            </button>
        </div>


    </div>);
};

export default TestCallDescription;
